import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../hooks/storeHooks";
import { DefectTabs } from "../../types/DefectTabs";
import { classNames } from "primereact/utils";
import { useCallback, useMemo } from "react";
import { setActiveTab } from "../../store/slices/defectSlice";
import { getDefectSummaryAggregates } from "./DefectsSummaryDataHelper";
import { defaultSharedDefectsFiltersConfig } from "../DefectsTable/Filters/FilterTemplates";
import { setSharedDefectsTableFilterData } from "../../store/slices/filtersSlice";
import { setKeywordSearch } from "../../store/slices/filtersSlice";
import { selectKeywordSearch } from "../../store/selectors/filtersSelectors";
import { useAppSelector } from "../../hooks/storeHooks";
import { SharedDefectTableFields } from "../DefectsTable/SharedDefectTableFields";
import { DefectPriority } from "../../types/DefectPriority";
import { FilterMatchMode } from "primereact/api";

export const SharedDefectsSummaryAggregates = (props: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("locale");
    const keywordSearch = useAppSelector(selectKeywordSearch);

    const { defectAggregates } = props;

    const aggregates = useMemo(() => 
        getDefectSummaryAggregates(defectAggregates)
    , [defectAggregates]);

    const onClickDefectsTotal = useCallback(() => {
        if (aggregates.defectsTotal) {
            dispatch(setSharedDefectsTableFilterData(defaultSharedDefectsFiltersConfig));
            dispatch(setKeywordSearch({ ...keywordSearch, sharedDefects: "" }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.defectsTotal, keywordSearch, dispatch]);

    const onClickHighPriorityTotal = useCallback(() => {
        if (aggregates.highPriorityTotal) {
            dispatch(setSharedDefectsTableFilterData({
                ...defaultSharedDefectsFiltersConfig,
                [SharedDefectTableFields.PRIORITY]: { value: [DefectPriority.high], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setKeywordSearch({ ...keywordSearch, sharedDefects: "" }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.highPriorityTotal, keywordSearch, dispatch]);

    const onClickMediumPriorityTotal = useCallback(() => {
        if (aggregates.mediumPriorityTotal) {
            dispatch(setSharedDefectsTableFilterData({
                ...defaultSharedDefectsFiltersConfig,
                [SharedDefectTableFields.PRIORITY]: { value: [DefectPriority.medium], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setKeywordSearch({ ...keywordSearch, sharedDefects: "" }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.mediumPriorityTotal, keywordSearch, dispatch]);

    const onClickLowPriorityTotal = useCallback(() => {
        if (aggregates.lowPriorityTotal) {
            dispatch(setSharedDefectsTableFilterData({
                ...defaultSharedDefectsFiltersConfig,
                [SharedDefectTableFields.PRIORITY]: { value: [DefectPriority.low], matchMode: FilterMatchMode.IN }
            }));
            dispatch(setKeywordSearch({ ...keywordSearch, sharedDefects: "" }));
            dispatch(setActiveTab(DefectTabs.defects));
        }
    }, [aggregates.lowPriorityTotal, keywordSearch, dispatch]);
    
    return (
        <div className="grid flex mt-3 mr-0 ml-0 mb-3 gap-3">
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.defectsTotal")}</span>
                <span 
                    className={classNames(aggregates.defectsTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickDefectsTotal}
                >
                    {aggregates.defectsTotal}
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.highPriorityTotal")}</span>
                <span 
                    className={classNames(aggregates.highPriorityTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickHighPriorityTotal}
                >
                    <img src="/high.svg" className="priority-icon-size-small m-auto" />
                    <span className="flex-1 text-center">{aggregates.highPriorityTotal}</span>
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.mediumPriorityTotal")}</span>
                <span
                    className={classNames(aggregates.mediumPriorityTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickMediumPriorityTotal}
                >
                    <img src="/medium.svg" className="priority-icon-size-small m-auto" />
                    <span className="flex-1 text-center">{aggregates.mediumPriorityTotal}</span>
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="defects-aggregate-label">{t("defectsSummary.lowPriorityTotal")}</span>
                <span
                    className={classNames(aggregates.lowPriorityTotal ? "cursor-pointer read-more-btn underline" : "font-normal", "defects-aggregate-count mt-1")}
                    onClick={onClickLowPriorityTotal}
                >
                    <img src="/low.svg" className="priority-icon-size-small m-auto" />
                    <span className="flex-1 text-center">{aggregates.lowPriorityTotal}</span>
                </span>
            </div>
        </div>
    )
};
